const header = document.querySelector('header.site-header');
if (header) {
    let headerLinks = document.querySelectorAll('.site-header .menu li a');
    headerLinks.forEach(function(link) {
        link.addEventListener('click', function() {
            header.classList.remove('is-open');
        });
    });
    document.querySelector('.menu-trigger').addEventListener('click', function(e) {
        header.classList.toggle('is-open');
    });

}


function setResponsiveVideo() {
    let videos = document.querySelectorAll('video');
    if (videos) {
        videos.forEach((video) => {
            if (window.innerWidth < 800) {
                video.setAttribute('src', video.dataset.src_mobile);
            } else {
                video.setAttribute('src', video.dataset.src);
            }
        })
    }
}
setResponsiveVideo();

let solutionsMenu = document.querySelector('li.solutions-menu');
if (solutionsMenu) {
    solutionsMenu.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        this.classList.toggle('active');
        let megaMenu = this.querySelector('.mega-menu');
        if (megaMenu) {
            megaMenu.classList.toggle('hidden');
            megaMenu.addEventListener('click', function(e) {
                e.stopPropagation();
            });
        }
    });
}

let tabLinks = document.querySelectorAll('.tab-links a');
if (tabLinks) {
    tabLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();

            let targetId = link.getAttribute('href').substring(1);
            let panel = document.getElementById(targetId);
            if (panel) {
                let allPanels = document.querySelectorAll('.tab-panels .panel');
                allPanels.forEach(p => p.classList.add('hidden'));
                panel.classList.remove('hidden');

                let allLinks = document.querySelectorAll('.tab-links a');
                allLinks.forEach(l => l.classList.remove('active'));
                link.classList.add('active');
            }
        });
    });
}

/*document.querySelectorAll('.accordion details').forEach(detail => {
    const summary = detail.querySelector('summary');
    const content = detail.querySelector('.content');
    content.style.overflow = 'hidden';
    content.style.height = detail.open ? content.scrollHeight + 'px' : '0px';

    summary.addEventListener('click', function(e) {
        e.preventDefault();
        if (detail.open) {
            content.style.height = content.scrollHeight + 'px';
            requestAnimationFrame(() => {
                content.style.height = '0px';
            });
            content.addEventListener('transitionend', function handler() {
                detail.open = false;
                content.removeEventListener('transitionend', handler);
            });
        } else {
            detail.open = true;
            content.style.height = '0px';
            requestAnimationFrame(() => {
                content.style.height = content.scrollHeight + 'px';
            });
        }
    });
});*/

let accordion = document.querySelector('.accordion');
if (accordion) {
    let details = accordion.querySelectorAll('details');
    details.forEach(detail => {
        detail.addEventListener('click', function(e) {
            details.forEach(d => {
                if (d !== detail) {
                    d.removeAttribute('open');
                }
            });
            const content = detail.querySelector('.content');
            detail.addEventListener('toggle', function() {
                if (detail.open) {
                    content.style.height = content.scrollHeight + 'px';
                } else {
                    content.style.height = '0px';
                }
            });
        });
    });
}

let postsCategorySelect = document.querySelector('select[name="category"]');
if (postsCategorySelect) {
    // make fetch request to get posts by category with action get_posts_by_category
    postsCategorySelect.addEventListener('change', function() {
        // get selected option data-link attribute
        let link = this.options[this.selectedIndex].dataset.link;
        console.log(link);
        if (link) {
            window.location.href = link;
        }
        /*let category = this.value;
        let data = new FormData();
        data.append('action', 'filter_posts_by_category');
        data.append('category', category);

        // get html from ajax request
        fetch('/wp-admin/admin-ajax.php', {
            method: 'POST',
            body: data
        }).then(response => response.text())
        .then(html => {
            let postsContainer = document.querySelector('.bg-gradient .wp-block-group__inner-container');
            if (postsContainer) {
                //postsContainer.innerHTML = html;

            }
        });*/
    });
}
